import { createTableSlice } from '../helpers';

export const tableSlice = createTableSlice({
  name: 'notifications/seenTable',
  url: '/api/notifications',
  filters: {
    seen: 1,
  },
});
